import { render, staticRenderFns } from "./SidebarPos.vue?vue&type=template&id=2da9d1a6&scoped=true&"
import script from "./SidebarPos.vue?vue&type=script&lang=js&"
export * from "./SidebarPos.vue?vue&type=script&lang=js&"
import style0 from "./SidebarPos.vue?vue&type=style&index=0&id=2da9d1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9d1a6",
  null
  
)

export default component.exports